import React, { useState } from 'react'
import { useChain } from '../chainState'
import { TaskItem } from './TaskItem'

export const ChainCompletionScreen = () => {
  const [chainState, dispatch] = useChain()
  const { title, description, simulations, activityPk, coursenum, completionUrl, completionButtonText } = chainState
  const [expandedSims, setExpandedSims] = useState(new Set())

  const toggleExpanded = index => {
    setExpandedSims(prev => {
      const next = new Set(prev)
      if (next.has(index)) {
        next.delete(index)
      } else {
        next.add(index)
      }
      return next
    })
  }

  return (
    <div className="chain-completion-screen">
      <div className="chain-completion-header">
        <i className="fa-solid fa-circle-check" aria-hidden="true" />
        <h2>All Simulations Complete!</h2>
      </div>

      {(title || description) && (
        <div className="chain-completion-info">
          {title && <h3>{title}</h3>}
          {description && <p>{description}</p>}
        </div>
      )}

      <div className="chain-completion-sim-list">
        {simulations.map((sim, index) => {
          const tasks = sim.completedTasks || []
          const isExpanded = expandedSims.has(index)
          const hasSnapshot = !!sim.stateSnapshot

          return (
            <div key={index} className="chain-completion-sim-card">
              <div
                className="chain-completion-sim-card-header"
                onClick={tasks.length > 0 ? () => toggleExpanded(index) : undefined}
                style={tasks.length > 0 ? { cursor: 'pointer' } : undefined}
                role={tasks.length > 0 ? 'button' : undefined}
                aria-expanded={tasks.length > 0 ? isExpanded : undefined}
              >
                <div className="chain-completion-sim-card-title">
                  <i className="fa-regular fa-circle-check text-success" aria-hidden="true" />
                  <span>{sim.title || `Simulation ${index + 1}`}</span>
                </div>
                <div className="chain-completion-sim-card-meta">
                  <span className="chain-completion-task-count">
                    {tasks.length} {tasks.length === 1 ? 'task' : 'tasks'}
                  </span>
                  {tasks.length > 0 && (
                    <i
                      className={`fa-solid fa-chevron-${isExpanded ? 'up' : 'down'} text-muted`}
                      style={{ fontSize: '0.75rem' }}
                      aria-hidden="true"
                    />
                  )}
                </div>
              </div>

              {isExpanded && tasks.length > 0 && (
                <div className="chain-completion-sim-card-tasks">
                  <div className="simulation-task-list" role="list" aria-label={`${sim.title || 'Simulation'} tasks`}>
                    {tasks.map((task, taskIndex) => (
                      <TaskItem key={task.id} task={task} index={taskIndex} />
                    ))}
                  </div>
                </div>
              )}

              {hasSnapshot && (
                <div className="chain-completion-sim-card-actions">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => dispatch({ type: 'SET_REVIEW_INDEX', payload: index })}
                  >
                    <i className="fa-regular fa-eye" aria-hidden="true" /> Review
                  </button>
                </div>
              )}
            </div>
          )
        })}
      </div>

      {activityPk ? (
        <p className="chain-completion-submit-prompt">
          When you&apos;re ready, click <strong>Submit</strong> below to finalize your work.
        </p>
      ) : (
        <div className="chain-completion-continue">
          <a
            href={completionUrl || (coursenum ? `/reader/web/${coursenum}/` : '#')}
            className="chain-completion-continue-btn"
          >
            {completionButtonText || 'Continue'}
          </a>
        </div>
      )}
    </div>
  )
}
